import { Link } from "react-router-dom";
import { Fuel, Gauge, Calendar, Cog } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { photoUrl, fmtKm, vehicleTitle } from "@/lib/vehicles";

const Spec = ({ icon: Icon, children }) => (
  <span className="flex items-center gap-1.5 text-xs text-slate-400"><Icon className="h-3.5 w-3.5 text-[#2F7BFF]" />{children}</span>
);

export const VehicleCard = ({ v }) => {
  const { t, lang } = useLang();
  const tv = t.vehicles;
  return (
    <Link to={`/vehicles/${v.id}`} data-testid={`vehicle-card-${v.id}`} className="group flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0B1224] transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#2F7BFF]/50 hover:shadow-[0_20px_50px_-20px_rgba(47,123,255,.6)]">
      <div className="relative aspect-[4/3] overflow-hidden bg-white/5">
        {v.photos[0] && <img src={photoUrl(v.photos[0])} alt={vehicleTitle(v)} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
        <div className="absolute left-3 top-3 flex gap-2">
          {v.status === "reserved" && <span className="rounded-full bg-amber-400/90 px-2.5 py-1 text-[11px] font-bold uppercase text-[#0B1224]">{tv.status.reserved}</span>}
          {v.is_sample && <span data-testid="vehicle-sample-badge" className="rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-bold uppercase text-[#0B1224]">{tv.sample}</span>}
        </div>
        {v.quantity > 1 && <span className="absolute right-3 top-3 rounded-full bg-[#2F7BFF] px-2.5 py-1 text-[11px] font-bold text-white">{v.quantity}× {tv.units}</span>}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-bold text-white">{vehicleTitle(v)}</h3>
        <p className="mt-0.5 truncate text-sm text-slate-400">{v.variant || "\u00a0"}</p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <Spec icon={Calendar}>{v.year}</Spec>
          <Spec icon={Gauge}>{fmtKm(v.mileage_km, lang)}</Spec>
          <Spec icon={Fuel}>{tv.fuel[v.fuel]}</Spec>
          <Spec icon={Cog}>{tv.transmission[v.transmission]}</Spec>
        </div>
        <div className="mt-5 flex items-end justify-between border-t border-white/10 pt-4">
          <div>
            <div data-testid="vehicle-card-price" className="font-display text-lg font-bold text-[#7FB2FF]">{tv.requestPrice}</div>
            <div className="text-[11px] text-slate-400">{tv.b2bOnly}</div>
          </div>
          <span className="text-sm font-bold text-[#2F7BFF] transition-transform group-hover:translate-x-1">{tv.details} →</span>
        </div>
      </div>
    </Link>
  );
};
